export type TrialBannerStage =
  | "trial_unlimited"
  | "basic"
  | "read_only"
  | "suspended"
  | "licensed";

export type TrialBanner = {
  visible: boolean;
  stage: TrialBannerStage;
  label: string;
  message: string;
  expires_at: string | null;
  days_remaining: number | null;
  next_stage: TrialBannerStage | null;
  server_now: string;
  cta: {
    primary: string;
    href: string;
  } | null;
};

export function canReadCommercialState(
  _role: string | null | undefined,
  orgId: string | null | undefined,
  capabilities?: {
    canManageOrgAppointments?: boolean;
    canManageOrgEegConfig?: boolean;
    canAccessMedicalCoding?: boolean;
  },
): boolean {
  if (!orgId) return false;
  if (!capabilities) return false;

  return Boolean(
    capabilities.canManageOrgAppointments ||
      capabilities.canManageOrgEegConfig ||
      capabilities.canAccessMedicalCoding,
  );
}

export function resolveTrialBannerClass(stage: TrialBannerStage): string {
  if (stage === "read_only") return "alert-warning";
  if (stage === "suspended") return "alert-danger";
  return "alert-info";
}

export function formatTrialBannerDate(
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDaysLeft(
  daysRemaining: number | null | undefined,
): string {
  if (typeof daysRemaining !== "number") return "Active";
  if (daysRemaining <= 0) return "Expires today";
  if (daysRemaining === 1) return "1 day left";
  return `${daysRemaining} days left`;
}
